import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/services/api'
import {
  ConfigRequest,
  ConfigRequestFilter,
  ConfigRequestListResponse,
  ConfigRequestPendingCountResponse,
  UpdateConfigRequestPayload,
} from '@/types'
import { toast } from 'sonner'

const CONFIG_REQUESTS_QUERY_KEY = 'config-requests'

export const useConfigRequests = (filters: ConfigRequestFilter = {}) => {
  return useQuery<ConfigRequestListResponse>({
    queryKey: [CONFIG_REQUESTS_QUERY_KEY, filters],
    queryFn: async () => {
      const params = new URLSearchParams()
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value))
        }
      })

      const { data } = await api.get(`/config-requests?${params.toString()}`)
      return data
    },
  })
}

export const useConfigRequest = (id: string) => {
  return useQuery<ConfigRequest>({
    queryKey: [CONFIG_REQUESTS_QUERY_KEY, id],
    queryFn: async () => {
      const { data } = await api.get(`/config-requests/${id}`)
      return data
    },
    enabled: !!id,
  })
}

export const useConfigRequestsPendingCount = () => {
  return useQuery<ConfigRequestPendingCountResponse>({
    queryKey: [CONFIG_REQUESTS_QUERY_KEY, 'pending-count'],
    queryFn: async () => {
      const { data } = await api.get('/config-requests/count')
      return data
    },
    refetchInterval: 60_000,
  })
}

export const useUpdateConfigRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateConfigRequestPayload }) => {
      const { data } = await api.patch<ConfigRequest>(`/config-requests/${id}`, payload)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CONFIG_REQUESTS_QUERY_KEY] })
      toast.success('Solicitud actualizada')
    },
  })
}
